module.exports = __webpack_public_path__ + "static/media/icpc.7d3c7926.jpeg";